const UserActionTypes = {
    SET_TOTAL_USERS: "SET_TOTAL_USERS",
    FETCH_ADMIN_USERS_START: "FETCH_ADMIN_USERS_START",
    FETCH_ADMIN_USERS_SUCCESS: "FETCH_ADMIN_USERS_SUCCESS",
    FETCH_ADMIN_USERS_FAILURE: "FETCH_ADMIN_USERS_FAILURE",
};

export default UserActionTypes;
